import { defineStyleConfig } from "@chakra-ui/react"

export const Link = defineStyleConfig({
	baseStyle: {
		textDecoration: "underline",
		textUnderlineOffset: "2px",
		color: "primary.500",
	},
})
